<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="70px" size="mini">
          <el-form-item label="标题" prop="title">
            <el-input class="form-input" v-model="searchForm.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="searchForm.type" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option v-for="item in typeOptions"
                :key="item.dictId"
                :label="item.dictDataValue"
                :value="item.dictDataCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人" prop="createdName">
            <el-input class="form-input" v-model="searchForm.createdName" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编辑时间" prop="updatedTime">
            <q-date-picker startFiled="updatedTimeStart" :isDefault="false" endFiled="updatedTimeEnd" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="handleAdd(null, 1)">新增</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        :data="tableData"
        border
        :height="maxTableHeight">
        <el-table-column prop="title" label="标题"  show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="type" label="类型" width="120"></el-table-column>
        <el-table-column prop="pv" label="浏览量" width="120" align="center"></el-table-column>
        <el-table-column prop="uv" label="浏览人数" width="120" align="center"></el-table-column>
        <el-table-column prop="createdName" label="创建人" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updatedTime" label="编辑时间" align="center" width="155">
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.status | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="280" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button v-if="scope.row.status == 0" type="text" size="small" @click="handleState(scope.row, 1)">下线</el-button>
            <el-button v-else type="text" size="small" @click="handleState(scope.row, 0)">上线</el-button>
            <el-button v-if="scope.row.status == 1" type="text" size="small" @click="handleAdd(scope.row, 2)">修改</el-button>
            <el-button type="text" size="small" @click="handleAdd(scope.row, 3)">查看</el-button>
            <el-button v-if="scope.row.status == 1" type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
            <el-button type="text" size="small" v-if="scope.$index != 0" @click="moveUp(scope.$index)">上移</el-button>
            <el-button type="text" size="small" v-if="scope.$index != tableDataLength-1"  @click="moveDown(scope.$index)">下移</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <newadd-help
      v-if="isShowAdd" 
      :visible.sync="isShowAdd" 
      :modifyData="modifyData" 
      :actionType="actionType"
      :typeOptions="typeOptions"
      @success="getList"
    />
  </content-panel>
</template>

<script>
import newaddHelp from './newAdd'
import tableMixin from '@/utils/tableMixin';
export default {
  name: "helpList",
  mixins: [tableMixin],
  components: {
    newaddHelp
  },
  data() {
    return {
      searchForm: {
        title: '',
        type: '',
        createdName: '',
        status: '',
        updatedTimeStart: '',
        updatedTimeEnd: '',
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      typeOptions: [],
      statusOptions: [
        {value: '', label: '全部'},
        {value: 0, label: '使用中'},
        {value: 1, label: '已下线'},
      ],
      actionType: 1,
      isShowAdd: false,
      modifyData: null
    }
  },
  computed: {
    tableDataLength() {
      return this.tableData.length
    },
  },
  methods: {
    init() {
      this.onSearch();
      this.getDictData()
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam
        }
      }
      this.$api.help.queryDocumentList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.updatedTimeStart = ''
      this.searchForm.updatedTimeEnd = ''
      this.$refs.dateRef.reset()
    },
    getDictData() {
      this.$api.help.getDictData('document_type')
        .then(res => {
          this.typeOptions = res.data
        })
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;
    },
    handleState(row, state) {
      this.$api.help
        .onlineOrOfflineDocument(row.id, state)
        .then(({data}) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.getList();
        });
    },
    handleDelete(row) {
      this.$confirm('删除后数据不可恢复，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.help
            .deleteDocument(row.id)
            .then(({data}) => {
              this.$notify.success({
                title: '成功',
                message: '删除成功',
              });
              this.getList();
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    moveUp(index) {
      this.$api.common.removeSeq({
        businessCode: 'document',
        fromKey:  this.tableData[index].id,
        fromSeq: this.tableData[index].seqNumber,
        toKey: this.tableData[index-1].id,
        toSeq: this.tableData[index-1].seqNumber,
      }).then(res => {
         this.onSearch();
        // this.tableData[index] = this.tableData.splice(index-1, 1, this.tableData[index])[0]
      })
      
    },
    moveDown(index){
      this.$api.common.removeSeq({
        businessCode: 'document',
        fromKey:  this.tableData[index].id,
        fromSeq: this.tableData[index].seqNumber,
        toKey: this.tableData[index+1].id,
        toSeq: this.tableData[index+1].seqNumber,
      }).then(res => {
        //  this.tableData[index] = this.tableData.splice(index+1, 1, this.tableData[index])[0]
        this.onSearch();
      })
     
    }
  },
  filters: {
    statusEnum(val) {
      const map = {
        0: '使用中',
        1: '已下线',
        2: '已删除',
      };
      return map[val] || '';
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input {
  width 130px !important
}
.to {
  display: inline-block;
  margin: 0 4px;
}
</style>